import { render, staticRenderFns } from "./patient-form.vue?vue&type=template&id=ecd0468a&scoped=true&lang=pug&"
import script from "./patient-form.vue?vue&type=script&lang=ts&"
export * from "./patient-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd0468a",
  null
  
)

export default component.exports